<div class="flex flex-column md:flex-row align-items-stretch gap-3 mb-2">
  <app-metric
    class="w-12 md:w-6"
    title="Σύνολο ήδη ανατεθειμένων χειρουργείων"
    subtitle=""
    [value]="assignedSurgeriesCount"
    icon="pi pi-thumbs-up text-white"
    iconBg="bg-green-500"
    pTooltip="Ο αριθμός διαφέρει ανάλογα με το νοσοκομείο και την κλινική."
    tooltipPosition="top"
    [loading]="isAssignedSurgeriesLoading()"
  />
  <app-metric
    class="w-12 md:w-6"
    title="Σύνολο μη ανατεθειμένων χειρουργείων"
    subtitle=""
    [value]="unAssignedSurgeriesCount"
    icon="pi pi-thumbs-down text-white"
    iconBg="bg-red-500"
    pTooltip="Ο αριθμός διαφέρει ανάλογα με το νοσοκομείο και την κλινική."
    tooltipPosition="top"
    [loading]="isUnAssignedSurgeriesLoading()"
  />
</div>

<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isSurgeryLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch($event)"
  [customFormControls]="{
    hospitalID: hospitalID,
    clinicID: clinicID,
    patientAmka: patientAmka
  }"
  [initData]="false"
  [collapsed]="false"
  [showClearButton]="false"
>
  <ng-template
    #hospitalID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-hospital-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        (change)="onHospitalChange($event)"
        formControlName="hospitalID"
        [showClear]="true"
      />
    </ng-container>
  </ng-template>
  <ng-template
    #clinicID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-clinic-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        formControlName="clinicID"
        [hospitalId]="hospitalId"
        [showClear]="true"
      />
    </ng-container>
  </ng-template>
  <ng-template
    #patientAmka
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <eo-input
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        formControlName="patientAmka"
        placeholder="Παρακαλώ συμπληρώστε το ΑΜΚΑ Ασθενούς"
        (input)="updateHospitalIDControlValidator($event)"
      />
    </ng-container>
  </ng-template>
</eo-search-page>

<app-surgery-assign-form-dialog
  #surgeryAssignFormDialog
  (success)="onAssignSurgeryFormSuccess()"
/>

<p-confirmPopup key="returnSurgeryPopup" [style]="{ width: '700px' }">
</p-confirmPopup>

<p-confirmPopup key="toPrivateClinicPopup" [style]="{ width: '700px' }">
</p-confirmPopup>
